(function () {
  class MultiplierDisplay extends PIXI.Container {
    constructor() {
      super();
      this.initialised = false;

      this.multiplierActive = false;

      this.boostTask = undefined;

      this.currentStep = 0;
      this.targetStep = 0;

      this.idle = true;

      const self = this;

      StateMachine.Create(this);
      Reflex.addToUpdate(function () {
        self.update();
      });

      this.stateMachine.addState('IDLE', () => {
        if (this.phase.enter()) {
          console.log('multiplierDisplay now idle');
          this.idle = true;
        }
        if (this.phase.exit()) {
          this.idle = false;
          console.log('multiplierDisplay NOT idle');
        }
      });
      this.stateMachine.addState('INITIALMULTIPLIER', function () {
        self.update_initialMultiplier();
      });
      // this.stateMachine.addState('BOOSTMULTIPLIER', function () {
      //   self.update_boostMultiplier();
      // });
      this.stateMachine.addState('INCREASEMULTIPLIER', function () {
        self.update_increaseMultiplier();
      });
      this.stateMachine.addState('CLOSEMULTIPLIER', function () {
        self.update_closeMultiplier();
      });

      this.resetMultiplierValues();

      this.stateMachine.switchState('IDLE');
    }

    isIdle() {
      return this.idle;
    }

    //////////////////////////////////////////////////
    initialise() {
      const self = this;

      messageBus.subscribe('spinner:GameConfigEvent', function () {
        self.onLayoutComplete();
      });
    }

    //////////////////////////////////////////////////
    isMultiplierActive() {
      return this.multiplierActive;
    }

    //////////////////////////////////////////////////
    onLayoutComplete() {
      let baseName = 'multiDisplay:multiplierDisplay:';

      this.newText = [];
      this.frontText = [];
      this.midText = [];
      this.backText = [];

      // BACK
      this.multiplierBack = resourceManager.get(baseName + 'multiplierBack');
      this.multiplierBackPos = {
        x: this.multiplierBack.x,
        y: this.multiplierBack.y,
      };

      this.backText.push(resourceManager.get(baseName + 'multiplierBackTextL'));
      this.backText.push(resourceManager.get(baseName + 'multiplierBackTextM'));
      this.backText.push(resourceManager.get(baseName + 'multiplierBackTextS'));
      this.backTextFilter = new PIXI.filters.ColorMatrixFilter();
      this.backTextFilter.enabled = false;
      this.backTextFilter.resolution = 2;
      for (let i = 0; i < this.backText.length; i++) {
        this.backText[i].filters = [this.backTextFilter];
      }

      //this.multiplierBackText = resourceManager.get( baseName + "multiplierBackText" );
      this.backTextPos = {
        x: this.backText[0].x,
        y: this.backText[0].y,
      };

      // MID
      this.multiplierMid = resourceManager.get(baseName + 'multiplerMid');
      this.multiplierMidPos = {
        x: this.multiplierMid.x,
        y: this.multiplierMid.y,
      };

      this.midText.push(resourceManager.get(baseName + 'multiplierMidTextL'));
      this.midText.push(resourceManager.get(baseName + 'multiplierMidTextM'));
      this.midText.push(resourceManager.get(baseName + 'multiplierMidTextS'));
      this.midTextFilter = new PIXI.filters.ColorMatrixFilter();
      this.midTextFilter.enabled = false;
      this.midTextFilter.resolution = 2;
      for (let i = 0; i < this.midText.length; i++) {
        this.midText[i].filters = [this.midTextFilter];
      }

      // this.multiplierMidText = resourceManager.get( baseName + "multiplierMidText" );
      this.midTextPos = {
        x: this.midText[0].x,
        y: this.midText[0].y,
      };

      // FRONT
      this.multiplierFront = resourceManager.get(baseName + 'multiplierFront');
      this.multiplierFrontPos = {
        x: this.multiplierFront.x,
        y: this.multiplierFront.y,
      };
      this.frontText.push(resourceManager.get(baseName + 'multiplierFrontTextL'));
      this.frontText.push(resourceManager.get(baseName + 'multiplierFrontTextM'));
      this.frontText.push(resourceManager.get(baseName + 'multiplierFrontTextS'));
      this.frontTextFilter = new PIXI.filters.ColorMatrixFilter();
      this.frontTextFilter.enabled = false;
      this.frontTextFilter.resolution = 2;
      for (let i = 0; i < this.frontText.length; i++) {
        this.frontText[i].filters = [this.frontTextFilter];
      }

      //this.multiplierFrontText = resourceManager.get( baseName + "multiplierFrontText" );
      this.frontTextPos = {
        x: this.frontText[0].x,
        y: this.frontText[0].y,
      };

      // NEW
      this.multiplierNew = resourceManager.get(baseName + 'multiplierNew');
      this.multiplierNewPos = {
        x: this.multiplierNew.x,
        y: this.multiplierNew.y,
      };
      this.newText.push(resourceManager.get(baseName + 'multiplierNewTextL'));
      this.newText.push(resourceManager.get(baseName + 'multiplierNewTextM'));
      this.newText.push(resourceManager.get(baseName + 'multiplierNewTextS'));
      this.newTextFilter = new PIXI.filters.ColorMatrixFilter();
      this.newTextFilter.enabled = false;
      this.newTextFilter.resolution = 2;
      for (let i = 0; i < this.newText.length; i++) {
        this.newText[i].filters = [this.newTextFilter];
      }

      this.newTextPos = {
        x: this.newText[0].x,
        y: this.newText[0].y,
      };

      // LANTERN ANIM
      this.burstAnim = resourceManager.get(baseName + 'burstAnim');
      this.burstAnim.gotoAndStop(0);
      this.burstAnim.visible = false;

      //this.frontOffPos = { x:this.frontText[0].position.x, y:this.frontText[0].position.y + 100 };
      this.setFrontOffset();

      this.setLayoutScaleFactor();

      // set the background circles to scale
      this.setupInitialScales();

      // sets initial values and visibilty
      this.updateMultiplierText();

      messageBus.subscribe('FastFruits:boostMulti', this.boostMultiplier.bind(this));
      Reflex.registerEventHandler('orientationChange', this.onOrientationChange.bind(this));

      messageBus.subscribe('layoutController:backFromReplay', this.backFromReplay.bind(this));

      this.themeForBaseGame();
    }

    themeForFreeSpins() {
      this.multiplierBack.gotoAndStop(1);
      this.multiplierMid.gotoAndStop(1);
      this.multiplierFront.gotoAndStop(1);
      this.multiplierNew.gotoAndStop(1);
    }

    themeForBaseGame() {
      this.multiplierBack.gotoAndStop(0);
      this.multiplierMid.gotoAndStop(0);
      this.multiplierFront.gotoAndStop(0);
      this.multiplierNew.gotoAndStop(0);
    }

    backFromReplay() {
      this.onOrientationChange();
      this.setupInitialScales();
    }

    //////////////////////////////////////////////////
    setLayoutScaleFactor() {
      this.scaleFactor = 1.0;

      switch (layoutController.getCurrentLayout()) {
        // PORTRAIT Mobile runs at 90% scale
        case 'portrait_mobile':
        case 'portrait_default':
          this.scaleFactor = 0.9;
          break;
      }

      this.newScale = 0 * this.scaleFactor;
      this.backScale = 0.5 * this.scaleFactor;
      this.midScale = 0.7 * this.scaleFactor;
      this.frontScale = 1.0 * this.scaleFactor;
    }

    //////////////////////////////////////////////////
    setupInitialScales() {
      this.multiplierNew.scale.set(this.newScale);
      this.multiplierBack.scale.set(this.backScale);
      this.multiplierMid.scale.set(this.midScale);
      this.multiplierFront.scale.set(this.frontScale);

      this.setMultiplierScale(this.frontScale, this.midScale, this.backScale, this.newScale);
    }

    //////////////////////////////////////////////////
    onOrientationChange() {
      let baseName = 'multiDisplay:multiplierDisplay:';

      let tempPos = layoutController.getCurrentPosition(baseName + 'multiplierBackTextL');
      this.backTextPos.x = tempPos.x;
      this.backTextPos.y = tempPos.y;

      tempPos = layoutController.getCurrentPosition(baseName + 'multiplierMidTextL');
      this.midTextPos.x = tempPos.x;
      this.midTextPos.y = tempPos.y;

      tempPos = layoutController.getCurrentPosition(baseName + 'multiplierFrontTextL');
      this.frontTextPos.x = tempPos.x;
      this.frontTextPos.y = tempPos.y;

      tempPos = layoutController.getCurrentPosition(baseName + 'multiplierNewTextL');
      this.newTextPos.x = tempPos.x;
      this.newTextPos.y = tempPos.y;

      // now the panels
      tempPos = layoutController.getCurrentPosition(baseName + 'multiplierBack');
      this.multiplierBackPos.x = tempPos.x;
      this.multiplierBackPos.y = tempPos.y;

      tempPos = layoutController.getCurrentPosition(baseName + 'multiplerMid');
      this.multiplierMidPos.x = tempPos.x;
      this.multiplierMidPos.y = tempPos.y;

      tempPos = layoutController.getCurrentPosition(baseName + 'multiplierFront');
      this.multiplierFrontPos.x = tempPos.x;
      this.multiplierFrontPos.y = tempPos.y;

      tempPos = layoutController.getCurrentPosition(baseName + 'multiplierNew');
      this.multiplierNewPos.x = tempPos.x;
      this.multiplierNewPos.y = tempPos.y;

      this.setLayoutScaleFactor();

      this.setupInitialScales();
      this.setFrontOffset();
    }

    //////////////////////////////////////////////////
    setFrontOffset() {
      switch (layoutController.getCurrentLayout()) {
        // LANDSCAPE
        case 'landscape_default':
        case 'landscape_mobile':
          this.frontOffPos = {
            x: this.frontText[0].position.x,
            y: this.frontText[0].position.y + 100,
          };
          break;

        // PORTRAIT
        case 'portrait_default':
        case 'portrait_mobile':
          this.frontOffPos = {
            x: this.frontText[0].position.x + 100,
            y: this.frontText[0].position.y,
          };
          break;
      }
    }

    ////////////////////////////////////////////////// the initial entry
    openDoor(disableBurstAnim = false, cbWhenComplete = null) {
      this.cbWhenInitialComplete = cbWhenComplete;
      this.disableBurstAnim = disableBurstAnim;
      this.stateMachine.switchState('INITIALMULTIPLIER');
    }

    //////////////////////////////////////////////////
    increaseMultiplier(multiplier, disableBurstAnim = false, cbWhenComplete = null) {
      this.cbWhenIncrementComplete = cbWhenComplete;
      this.disableBurstAnim = disableBurstAnim;
      // not first attempt - close door, scroll values, open door with new value
      this.stateMachine.switchState('INCREASEMULTIPLIER');
    }

    //////////////////////////////////////////////////
    boostMultiplier(task) {
      this.boostTask = task.join();

      this.currentStep = 0;
      this.targetStep = task.data.multiSteps;

      this.stateMachine.switchState('BOOSTMULTIPLIER');
    }

    //////////////////////////////////////////////////
    closeDoor(force = false, switchToFreeSpins = false) {
      this.switchToFreeSpinsDuringClose = switchToFreeSpins;
      if (force || this.multiplierActive) {
        this.stateMachine.switchState('CLOSEMULTIPLIER');
      }
    }

    //////////////////////////////////////////////////
    setFontVisibility(fonts, multiplier) {
      // single digit
      fonts[0].visible = true;
      fonts[1].visible = false;
      fonts[2].visible = false;

      // // 0 = large, 1 = mid, 2 = small
      // if (multiplier < 10) {
      //   // single digit
      //   fonts[0].visible = true;
      //   fonts[1].visible = false;
      //   fonts[2].visible = false;
      // } else if (multiplier < 100) {
      //   // double digit
      //   fonts[0].visible = false;
      //   fonts[1].visible = true;
      //   fonts[2].visible = false;
      // } else {
      //   // triple digit
      //   fonts[0].visible = false;
      //   fonts[1].visible = false;
      //   fonts[2].visible = true;
      // }
    }

    //////////////////////////////////////////////////
    updateMultiplierText() {
      // set all text the same
      // number of items should be 3 - small/medium/large
      let numFonts = 3;
      for (let i = 0; i < numFonts; i++) {
        this.frontText[i].setText('X' + this.multipliers[0]);
        this.midText[i].setText('X' + this.multipliers[1]);
        this.backText[i].setText('X' + this.multipliers[2]);
        this.newText[i].setText('X' + this.multipliers[3]);

        // TEST DATA
        //  this.frontText[i].text = "x65536";// + this.multipliers[0];
        //  this.midText[i].text = "x32768";// + this.multipliers[1];
        //  this.backText[i].text = "x16384";// + this.multipliers[2];

        // this.frontText[i].text = "x1x2x3x4x5x6x7x8x9";//x" + this.multipliers[0];
        // this.midText[i].text = "x1x2x3x4x5x6x7x8x9";//"x" + this.multipliers[1];
        // this.backText[i].text = "x1x2x3x4x5x6x7x8x9";//"x" + this.multipliers[2];
      }

      this.setMultiplierScale(this.frontScale, this.midScale, this.backScale, this.newScale);

      // set visibility of fonts based on text width
      this.setFontVisibility(this.frontText, this.multipliers[0]);
      this.setFontVisibility(this.midText, this.multipliers[1]);
      this.setFontVisibility(this.backText, this.multipliers[2]);
      this.setFontVisibility(this.newText, this.multipliers[3]);
    }

    //////////////////////////////////////////////////
    setMultiplierTextPositions(frontPos, midPos, backPos, newPos) {
      let numFonts = 3;
      for (let i = 0; i < numFonts; i++) {
        if (backPos) {
          this.backText[i].position.set(backPos.x, backPos.y);
        }
        if (midPos) {
          this.midText[i].position.set(midPos.x, midPos.y);
        }
        if (frontPos) {
          this.frontText[i].position.set(frontPos.x, frontPos.y);
        }
        if (newPos) {
          this.newText[i].position.set(newPos.x, newPos.y);
        }
      }
    }

    setMultiplierPanelPositions(frontPos, midPos, backPos, newPos) {
      let numFonts = 3;
      for (let i = 0; i < numFonts; i++) {
        if (backPos) {
          this.multiplierBack.position.set(backPos.x, backPos.y);
        }
        if (midPos) {
          this.multiplierMid.position.set(midPos.x, midPos.y);
        }
        if (frontPos) {
          this.multiplierFront.position.set(frontPos.x, frontPos.y);
        }
        if (newPos) {
          this.multiplierNew.position.set(newPos.x, newPos.y);
        }
      }
    }

    updateFilter(filter, scale) {
      const minBrightness = 0;
      const t = Math.max(0, Math.min(scale, 1));
      const brightness = minBrightness + (1 - minBrightness) * t;
      filter.brightness(brightness, false);
      if (scale > 0) {
        filter.enabled = true;
      } else {
        filter.enabled = false;
      }
    }

    //////////////////////////////////////////////////
    setMultiplierScale(frontScale, midScale, backScale, newScale) {
      let numFonts = 3;
      for (let i = 0; i < numFonts; i++) {
        if (typeof backScale === 'number') {
          this.backText[i].scale.set(backScale);
          this.backText[i].checkBounds(backScale);
        }

        if (typeof midScale === 'number') {
          this.midText[i].scale.set(midScale);
          this.midText[i].checkBounds(midScale);
        }

        if (typeof frontScale === 'number') {
          this.frontText[i].scale.set(frontScale);
          this.frontText[i].checkBounds(frontScale);
        }

        if (typeof newScale === 'number') {
          this.newText[i].scale.set(newScale);
          this.newText[i].checkBounds(newScale);
        }
      }

      if (typeof backScale === 'number') {
        if (this.ignoreFilterUpdates !== true) {
          this.updateFilter(this.backTextFilter, backScale);
        }
        this.multiplierBack.scale.set(backScale);
      }
      if (typeof midScale === 'number') {
        if (this.ignoreFilterUpdates !== true) {
          this.updateFilter(this.midTextFilter, midScale);
        }
        this.multiplierMid.scale.set(midScale);
      }
      if (typeof frontScale === 'number') {
        if (this.ignoreFilterUpdates !== true) {
          this.updateFilter(this.frontTextFilter, frontScale);
        }
        this.multiplierFront.scale.set(frontScale);
      }
      if (typeof newScale === 'number') {
        if (this.ignoreFilterUpdates !== true) {
          this.updateFilter(this.newTextFilter, newScale);
        }
        this.multiplierNew.scale.set(newScale);
      }
    }

    //////////////////////////////////////////////////
    linearInterpolate(P1, P2, delta) {
      var x = P1.x + (P2.x - P1.x) * delta;
      var y = P1.y + (P2.y - P1.y) * delta;

      return { x: x, y: y };
    }

    resetMultiplierValues() {
      this.multiplierIndex = 4;
      this.multipliers = [1, 2, 4, 8]; // front, middle, back, duplicate
    }

    //////////////////////////////////////////////////
    incrementMultipliers() {
      var len = this.multipliers.length - 1;

      for (let i = 0; i < this.multipliers.length - 1; i++) {
        this.multipliers[i] = this.multipliers[i + 1];
      }
      this.multipliers[len] *= 2;
      this.multiplierIndex++;
    }

    //////////////////////////////////////////////////
    // This moves the multipliers down by one position
    moveAndScale(progress) {
      let newBackPos = this.linearInterpolate(this.backTextPos, this.midTextPos, progress);
      let newMidPos = this.linearInterpolate(this.midTextPos, this.frontTextPos, progress);
      let newFrontPos = this.linearInterpolate(this.frontTextPos, this.frontOffPos, progress);

      this.setMultiplierTextPositions(newFrontPos, newMidPos, newBackPos);

      let backProgress = this.backScale + (this.midScale - this.backScale) * progress;
      let midProgress = this.midScale + (this.frontScale - this.midScale) * progress;
      // scale off the front value
      let frontProgress = 1 - progress;

      this.setMultiplierScale(frontProgress, midProgress, backProgress);
    }

    //////////////////////////////////////////////////
    // This moves the multipliers and panel down from mid to front
    moveAndScaleMidToFront(progress) {
      const newTextPos = this.linearInterpolate(this.midTextPos, this.frontTextPos, progress);
      const newPanelPos = this.linearInterpolate(this.multiplierMidPos, this.multiplierFrontPos, progress);
      const scale = this.midScale + (this.frontScale - this.midScale) * progress;

      this.setMultiplierTextPositions(null, newTextPos, null);
      this.setMultiplierPanelPositions(null, newPanelPos, null);
      this.setMultiplierScale(null, scale, null);
    }

    moveAndScaleBackToMid(progress) {
      const newTextPos = this.linearInterpolate(this.backTextPos, this.midTextPos, progress);
      const newPanelPos = this.linearInterpolate(this.multiplierBackPos, this.multiplierMidPos, progress);
      const scale = this.backScale + (this.midScale - this.backScale) * progress;

      this.setMultiplierTextPositions(null, null, newTextPos);
      this.setMultiplierPanelPositions(null, null, newPanelPos);
      this.setMultiplierScale(null, null, scale);
    }

    moveAndScaleNewToBack(progress) {
      // we need a newPos for
      const newTextPos = this.linearInterpolate(this.newTextPos, this.backTextPos, progress);
      const newPanelPos = this.linearInterpolate(this.multiplierNewPos, this.multiplierBackPos, progress);
      const scale = this.backScale * progress;
      this.multiplierNew.alpha = progress;
      for (let i = 0; i < this.newText.length; i++) {
        this.newText[i].alpha = progress;
      }

      this.setMultiplierTextPositions(null, null, null, newTextPos);
      this.setMultiplierPanelPositions(null, null, null, newPanelPos);
      this.setMultiplierScale(null, null, null, scale);
    }

    //////////////////////////////////////////////////
    setFinalScaleAndPosition() {
      // all multipliers should be in place now so add in correct values here
      this.setMultiplierTextPositions(this.frontTextPos, this.midTextPos, this.backTextPos, this.newTextPos);
      this.setMultiplierScale(this.frontScale, this.midScale, this.backScale, this.newScale);
      this.setMultiplierPanelPositions(
        this.multiplierFrontPos,
        this.multiplierMidPos,
        this.multiplierBackPos,
        this.multiplierNewPos
      );

      this.incrementMultipliers();
      this.updateMultiplierText();
    }

    //////////////////////////////////////////////////
    update_increaseMultiplier() {
      if (this.phase.enter()) {
      }

      if (this.phase.once()) {
        if (!this.disableBurstAnim) {
          this.burstAnim.gotoAndPlay(0);
          this.burstAnim.visible = true;
          // fade out front
          gsap.fromTo(this.multiplierFront, { alpha: 1 }, { alpha: 0, duration: 0.3 });
          gsap.fromTo(this.frontText, { alpha: 1 }, { alpha: 0, duration: 0.3 });
          soundManager.play('multiplierIncrease');
        }
      }

      if (this.phase.hold()) {
        if (!this.burstAnim.playing) {
          this.burstAnim.gotoAndStop(0);
          this.burstAnim.visible = false;
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        // prepare new multiplier value ready for anim
        for (let i = 0; i < this.frontText.length; i++) {
          this.newText[i].setText('X' + this.multipliers[3]);
        }
        // also reposition front so its drawn before back?
        // const parent = this.multiplierFront.parent;
        // parent.swapChildren(this.multiplierNew, this.multiplierFront);
      }

      // move mid to front
      if (this.phase.timed(350)) {
        // TODO have each font 3 times for each size
        // we need to move all positions down one and scale
        this.moveAndScaleMidToFront(this.phase.Progress);
        this.moveAndScaleBackToMid(this.phase.Progress);
        this.moveAndScaleNewToBack(this.phase.Progress);
      }

      if (this.phase.once()) {
        // revert all positions
        // front can go back now
        // const parent = this.multiplierFront.parent;
        // parent.swapChildren(this.multiplierNew, this.multiplierFront);
        this.setFinalScaleAndPosition();

        this.multiplierFront.alpha = 1;
        this.frontText[0].alpha = 1;
        this.frontText[1].alpha = 1;
        this.frontText[2].alpha = 1;

        // i need this here becaus paw modifier stops rendering them
        // and if i dont make them visible at the end, we get a very
        // slight flicker
        this.multiplierFront.renderable = true;
        this.frontText[0].renderable = true;
      }

      if (this.phase.once()) {
        if (this.cbWhenIncrementComplete) {
          this.cbWhenIncrementComplete();
        }
        this.stateMachine.switchState('IDLE');
      }
    }

    //////////////////////////////////////////////////
    update_closeMultiplier() {
      if (this.phase.enter()) {
        soundManager.play('multiplierReset');
      }

      if (this.phase.timed(250)) {
        // scale off old multipliers
        const newFrontScale = this.frontScale * (1 - this.phase.Progress);
        const newMidScale = this.midScale * (1 - this.phase.Progress);
        const newBackScale = this.backScale * (1 - this.phase.Progress);
        const newNewScale = this.newScale * (1 - this.phase.Progress);

        this.ignoreFilterUpdates = true;

        this.setMultiplierScale(newFrontScale, newMidScale, newBackScale, newNewScale);
      }

      if (this.phase.timed(100)) {
      }

      if (this.phase.once()) {
        if (this.switchToFreeSpinsDuringClose === true) {
          this.themeForFreeSpins();
        } else {
          this.themeForBaseGame();
        }
        this.resetMultiplierValues();
        this.updateMultiplierText();
        this.setMultiplierScale(0, 0, 0, 0);
      }

      if (this.phase.timed(250)) {
        // scale back in base multipliers
        const frontScaleIn = this.frontScale * this.phase.Progress;
        const midScaleIn = this.midScale * this.phase.Progress;
        const backScaleIn = this.backScale * this.phase.Progress;
        const newScaleIn = this.newScale * this.phase.Progress;

        this.setMultiplierScale(frontScaleIn, midScaleIn, backScaleIn, newScaleIn);
      }

      if (this.phase.once()) {
        this.ignoreFilterUpdates = false;
        this.setMultiplierScale(this.frontScale, this.midScale, this.backScale, this.newScale);
        this.multiplierActive = false;
        this.stateMachine.switchState('IDLE');
      }
    }

    //////////////////////////////////////////////////
    update_initialMultiplier() {
      if (this.phase.enter()) {
        this.multiplierActive = true;
      }

      if (this.phase.once()) {
        if (!this.disableBurstAnim) {
          this.burstAnim.gotoAndPlay(0);
          this.burstAnim.visible = true;
          // fade out front
          gsap.fromTo(this.multiplierFront, { alpha: 1 }, { alpha: 0, duration: 0.3 });
          gsap.fromTo(this.frontText, { alpha: 1 }, { alpha: 0, duration: 0.3 });
          soundManager.play('multiplierIncrease');
        }
      }

      if (this.phase.hold()) {
        if (!this.burstAnim.playing) {
          this.burstAnim.gotoAndStop(0);
          this.burstAnim.visible = false;
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        // prepare new multiplier value ready for anim
        for (let i = 0; i < this.frontText.length; i++) {
          this.frontText[i].setText('X' + this.multipliers[3]);
        }
        // also reposition front so its drawn before back?
        // const parent = this.multiplierFront.parent;
        // parent.swapChildren(this.multiplierNew, this.multiplierFront);
      }

      // move mid to front
      if (this.phase.timed(350)) {
        // TODO have each font 3 times for each size
        // we need to move all positions down one and scale
        this.moveAndScaleMidToFront(this.phase.Progress);
        this.moveAndScaleBackToMid(this.phase.Progress);
        this.moveAndScaleNewToBack(this.phase.Progress);
      }

      if (this.phase.once()) {
        // revert all positions
        // front can go back now
        // const parent = this.multiplierFront.parent;
        // parent.swapChildren(this.multiplierNew, this.multiplierFront);
        this.setFinalScaleAndPosition();

        this.multiplierFront.alpha = 1;
        this.frontText[0].alpha = 1;
        this.frontText[1].alpha = 1;
        this.frontText[2].alpha = 1;

        // i need this here becaus paw modifier stops rendering them
        // and if i dont make them visible at the end, we get a very
        // slight flicker
        this.multiplierFront.renderable = true;
        this.frontText[0].renderable = true;
      }

      if (this.phase.once()) {
        if (this.cbWhenInitialComplete) {
          this.cbWhenInitialComplete();
        }

        this.stateMachine.switchState('IDLE');
      }
    }

    //////////////////////////////////////////////////
    update() {
      if (this.stateMachine) {
        this.stateMachine.update();
      }
    }
  }

  //////////////////////////////////////////////////
  create = function (json) {
    return new MultiplierDisplay();
  };

  //////////////////////////////////////////////////
  initialise = function (json, container, resources) {
    container.initialise();
  };

  //////////////////////////////////////////////////
  getFilesRequired = function (json) {
    return ['', ''];
  };

  resourceManager.registerObjectType('multiplierDisplay', create, initialise, getFilesRequired);
})();
